/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InvoiceNoAuthEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * This is used for the checkout session redirect from stripe
   * @returns any No response body
   * @throws ApiError
   */
  public invoiceNoAuthCompletedCheckoutSessionRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this invoice.
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/invoice-no-auth/{id}/completed-checkout-session/',
      path: {
        'id': id,
      },
    });
  }

}
